export default __webpack_public_path__ + "media/images/close-76883977382567e14ae548a57ce82755.svg";